///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.atp_documents = abcsetup.atp_documents || {};
abcsetup.atp_documents.index = abcsetup.atp_documents.index || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.atp_documents.index = {
    init: function () {
        abcsetup.setTitle('Authorized Trading Partner Documents');

        // When invitation status toggle changes, update the data in the table.
        $(document).on('change', '.atp_status_toggle', event => {
            abcsetup.blockUI(true);
            window.location.href = '/atp_documents/?status=' + $(event.target).val();
        });

        $(document).on('click', '#dscsa-button', function(event) {
            let id = $(this).data('id');

            let statuses = {
                dscsa_statuses_1: $(this).data('dscsa-status-1'),
                dscsa_statuses_2: $(this).data('dscsa-status-2'),
                dscsa_statuses_3: $(this).data('dscsa-status-3'),
                dscsa_statuses_4: $(this).data('dscsa-status-4')
            };

            $.get('/atp_documents/dscsa', function(response) {
                if ($('body').find('#dscsa_modal').length <= 0) {
                    $('body').append(response);
                }
    
                $('#atp_document_id').val(id);

                Object.entries(statuses).forEach(([key, value]) => {
                    if (value == true) {
                       $('#'+key).prop('checked', true);
                    }
                });

                $('#dscsa_modal').modal('show');
            });
        });

        $(document).on('click', '.fei-button', function(event) {
            let atpDocumentId = $(this).val();

            axios.get('/atp_documents/validate_ein', {
                'params': {
                    'atpDocumentId': atpDocumentId
                }
            })
            .then(response => {
                let color = 'red';

                if (response.data.status == 'success') {
                    color = 'green';
                }

                $('#alerts-modal .modal-body').css({'color': color});
                $('#alerts-modal-dismiss-button').text('Close');

                abcsetup.alerts.show('FEI Number Status', response.data.message);
            })
            .catch(error => {
                console.error(error);
            })
        });

        $(document).on('click', '.supplier-list-action', function(e) {
            let key = $(this).data('id');
            let org_id = $(this).data('org-id');
            let modal_type = $(this).data('container');

            abcsetup.blockUI(true);

            axios.get('/api/atp_documents/'+org_id+'/vendor_contacts')
                .then(response => {
                    const contacts = response.data.contacts;
                    
                    let container = modal_type == 'view-contact-list'
                        ? $('#view-suppliers-'+key).find('.supplier-list')
                        : $('#send-request-'+key).find('.send-request-contact-list');
                    
                    container.children().remove();

                    /* disable download button if no contacts are found */
                    if (!contacts[0]) {
                        $('.vendor-download-btn-'+org_id).addClass('d-none');
                        container.append('<h5>No Supplier Contacts found.</h5>')
                    }

                    if (response.data.success && contacts.length) {
                        container.append(`
                            <table class="table table-sm table-striped">
                                <thead>
                                    <tr>
                                        <th>SAP Supplier #</th>
                                        <th>Supplier Name</th>
                                        <th>User Name</th>
                                        <th>Email Address</th>
                                        <th>Role Create Date</th>
                                    </tr>
                                </thead>
                                <tbody class="supplier-list-tbody">
                        `)

                        contacts.forEach(element => {
                            $('.supplier-list-tbody').append(`
                                <tr>
                                    <td>${element.vendor_id}</td>
                                    <td>${element.vendor_name}</td>
                                    <td>${element.name}</td>
                                    <td>${element.email_address}</td>
                                    <td>${element.create_date}</td>
                                </tr>
                            `);
                        });

                        container.append('</tbody></table>');
                    }

                    abcsetup.unblockUI();
                })
                .catch(error => {
                    console.error(error);
                });
        })
    },

    formatUsersResponse: function (usersArray) {
        var formattedUsers = [];
        var option = {};

        for (var i = 0; i < usersArray.data.length; i++) {
            for (var j = 0; j < usersArray.data[i].roles.length; j++) {
                option = { 'id': usersArray.data[i].roles[j].id, 'text': usersArray.data[i].name + ' (' + usersArray.data[i].roles[j].org.name + ' - ' + usersArray.data[i].roles[j].name + ')' };
                formattedUsers.push(option);
            }
        }

        return formattedUsers;
    },

}